import React, {useState} from "react";
import styles from "./OperationsBox.module.css";
import "ml-matrix";
import Matrix from "ml-matrix";

//function to round number to at most 3 decimal places, only if necessary
function roundToThree (num) {
    return (Math.round((num + Number.EPSILON) * 1000) / 1000)
}


const OperationsBox = () => {

    const [operation,setOperation] = useState("Addition");

    const [a1,seta1] = useState("");
    const [a2,seta2] = useState("");
    const [a3,seta3] = useState("");
    const [a4,seta4] = useState("");
    const [a5,seta5] = useState("");
    const [a6,seta6] = useState("");
    const [a7,seta7] = useState("");
    const [a8,seta8] = useState("");
    const [a9,seta9] = useState("");

    const [b1,setb1] = useState("");
    const [b2,setb2] = useState("");
    const [b3,setb3] = useState("");
    const [b4,setb4] = useState("");
    const [b5,setb5] = useState("");
    const [b6,setb6] = useState("");
    const [b7,setb7] = useState("");
    const [b8,setb8] = useState("");
    const [b9,setb9] = useState("");

    var materixA = [[a1,a2,a3],[a4,a5,a6],[a7,a8,a9]];
    var materixB = [[b1,b2,b3],[b4,b5,b6],[b7,b8,b9]];


        return (
            <div className={styles.box_wrapper}>
                <h2 className={styles.operation}>{operation}</h2>
                <input className={styles.inp_box} type = "int" name = "a1" value={a1} onChange={e => seta1(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "a2" value={a2} onChange={e => seta2(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "a3" value={a3} onChange={e => seta3(e.target.value)}/>
                <button className={styles.button} onClick = {() => setOperation("Addition")}>+</button>
                <input className={styles.inp_box} type = "int" name = "b1" value={b1} onChange={e => setb1(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "b2" value={b2} onChange={e => setb2(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "b3" value={b3} onChange={e => setb3(e.target.value)}/>
                <p />
                <input className={styles.inp_box} type = "int" name = "a4" value={a4} onChange={e => seta4(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "a5" value={a5} onChange={e => seta5(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "a6" value={a6} onChange={e => seta6(e.target.value)}/>
                <button className={styles.button} onClick = {() => setOperation("Subtraction")}>-</button>
                <input className={styles.inp_box} type = "int" name = "b4" value={b4} onChange={e => setb4(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "b5" value={b5} onChange={e => setb5(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "b6" value={b6} onChange={e => setb6(e.target.value)}/>
                <p />
                <input className={styles.inp_box} type = "int" name = "a7" value={a7} onChange={e => seta7(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "a8" value={a8} onChange={e => seta8(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "a9" value={a9} onChange={e => seta9(e.target.value)}/>
                <button className={styles.button} onClick = {() => setOperation("Multiplication")}>×</button>
                <input className={styles.inp_box} type = "int" name = "b7" value={b7} onChange={e => setb7(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "b8" value={b8} onChange={e => setb8(e.target.value)}/>
                <input className={styles.inp_box} type = "int" name = "b9" value={b9} onChange={e => setb9(e.target.value)}/>
                <p />
                <p className={styles.result}>The result is: {(operation==="Addition") ? <p>{Matrix.add(materixA,materixB).data.map(row => <p>
                        <span className={styles.out_box}>{roundToThree(row[0])}</span>
                        <span className={styles.out_box2}>{roundToThree(row[1])}</span>
                        <span className={styles.out_box}>{roundToThree(row[2])}</span></p>)} </p> :
                    (operation==="Subtraction") ?  <p>{Matrix.sub(materixA,materixB).data.map(row => <p><span className={styles.out_box}>{roundToThree(row[0])}</span>
                    <span className={styles.out_box2}>{roundToThree(row[1])}</span>
                    <span className={styles.out_box}>{roundToThree(row[2])}</span></p>)} </p>:
                        <p>{(new Matrix (materixA)).mmul(new Matrix (materixB)).data.map(row => <p><span className={styles.out_box}>{roundToThree(row[0])}</span>
                        <span className={styles.out_box2}>{roundToThree(row[1])}</span>
                        <span className={styles.out_box}>{roundToThree(row[2])}</span></p>)} </p>}
                </p>
            </div>
        );
    }
;

export default OperationsBox;